import { guardNumber } from "../numbers";
import type { ArticleQuantityState, Nullable, LoadCarrierListItem } from "../types";
import { gradeStockQuantity } from "./grade-stock-quantity";

/**
 * Grade a load carrier against its own thresholds, on what the yard holds.
 *
 * This is the one place the two entities read a different figure. An article is graded on what it
 * can still promise, because a reservation there is an order line owing a pick and it falls as the
 * pick is booked. A carrier's reservation counts what unfinished rounds have *promised*, and a
 * round's own promise is entered by the picker looking at this badge — so grading the remainder
 * would turn the row amber in the act of loading a truck, which is not a stock problem.
 *
 * `availableQuantity` is the figure a new order is held against, and the ordering screens show it
 * beside the balance rather than folding it into this grade. A carrier whose balance went negative
 * reads `empty` for the same reason an oversold article does — there is nothing to load, and how
 * far past nothing it went is not a grade.
 */
export function getLoadCarrierQuantityState(
	loadCarrier: Nullable<LoadCarrierListItem>,
): ArticleQuantityState {
	if (!loadCarrier) return "empty";
	return gradeStockQuantity(
		guardNumber(loadCarrier.stockBalance),
		guardNumber(loadCarrier.warningStockBalance),
		guardNumber(loadCarrier.minimumStockBalance),
	);
}
